import React from "react";

import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./styles";
import LetterItem from "../LetterItem";
const useStyles = makeStyles(styles);

function LetterSelector(props) {
  const classes = useStyles();
  const { letters } = props;
  const allLetters = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "X",
    "Z",
  ];
  return (
    <div className={classes.container}>
      <List disablePadding>
        {allLetters.map((item) => {
          let disable = true;
          if (letters.includes(item)) {
            disable = false;
          }
          return (
            <LetterItem
              key={item}
              letter={item}
              disable={disable}
              active={props.selectedLetter === item}
              onSelect={props.onToggleLetter}
            />
          );
        })}
      </List>
    </div>
  );
}

export default LetterSelector;
